import React from 'react';
import { connect } from 'react-redux';
import infoIcon from './info-empty.png';

import './InfoPanels.scss';

const InfoPanels = ({ infoButtonActive }) => {
  if (!infoButtonActive) {
    return null;
  }

  return (
    <>
      {/* Lưu ý Panel - Left Side */}
      <div className="info-panel info-panel--left">
        <div className="info-panel__header">
          <div className="info-panel__icon">
            <img src={infoIcon} alt="Info icon" />
          </div>
          <h3 className="info-panel__title">Lưu ý</h3>
        </div>

        <div className="info-panel__content">
          <p className="info-panel__text">
            Chúng tôi đã nỗ lực và cần trọng để hoàn thiện tài liệu này. Tuy
            nhiên tài liệu chỉ dùng với mục đích tham khảo. Hình ảnh, sơ đồ kỹ
            thuật, bố trí nội thất hay thông tin mô tả chỉ nhằm mục đích minh
            hoạ, không phải là thông tin hiện thực hay cam kết pháp lý. Thông
            tin chính thức căn cứ trên Hợp đồng mua bán. Tên căn hộ và ký hiệu
            căn hộ cho mục đích giới thiệu, tên căn hộ và ký hiệu căn hộ chính
            thức sẽ được ghi nhận tại Hợp đồng mua bán.
          </p>

          <div className="info-panel__section">
            <h4 className="info-panel__subtitle">Ghi chú</h4>
            <p className="info-panel__text">
              Diện tích sử dụng căn hộ say cùng sẽ được xác minh bởi đơn vị đo
              đạc
            </p>
          </div>
        </div>
      </div>

      {/* Project Info Panel - Right Side */}
      <div className="info-panel info-panel--right">
        <div className="info-panel__table">
          <div className="info-panel__row">
            <div className="info-panel__label">Tên dự án</div>
            <div className="info-panel__value">Aurora</div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">Quy mô dự án</div>
            <div className="info-panel__value">
              <div>2 toà tháp, 45 tầng</div>

              <div>3 tầng hầm</div>
            </div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">Số lượng thang máy</div>
            <div className="info-panel__value">11 thang/ toà</div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">Tổng diện tích</div>
            <div className="info-panel__value">9760m2</div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">Mật độ xây dựng</div>
            <div className="info-panel__value">35.3%</div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">Đơn vị phát triển</div>
            <div className="info-panel__value">
              <div>Vizion</div>
            </div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">Loại hình căn hộ</div>
            <div className="info-panel__value">
              Studio, 1PN, 2PN, 3PN, Duplex, Penhouse
            </div>
          </div>

          <div className="info-panel__row">
            <div className="info-panel__label">Hình thức sở hữu</div>
            <div className="info-panel__value">
              <div>Sở hữu lâu dài</div>
              <div>(Áp dụng đối với khách hàng quốc tịch Việt Nam)</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  infoButtonActive: state.iconButtons.infoButtonActive,
});

export default connect(mapStateToProps)(InfoPanels);
